export class Rank {
    id : number;
    rankCode : string;
    rankName : string;
}